import Presentation from './components/Presentation';
import ContactForm from './components/ContactForm';
import './App.css';
import LinksIcons from './components/LinksIcons';

function App() {
  return (
    <div className="App">
      <Presentation />
      <LinksIcons />
      <ContactForm />
    </div>
  );
}

export default App;
